<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h4 class="mb-0">الگوهای PM V2</h4>

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">عنوان</label>
          <input [(ngModel)]="SearchText" name="Filter_title" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="ReadData()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button (click)="Add()" type="button" class="btn btn-success" style="margin-left: 5px;"><i
              class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive" *ngIf="!Procssing">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>کد PM</th>
              <th>عنوان</th>
              <th>نسخه</th>
              <th>تعداد آیتم</th>
              <th>زمان تقریبی</th>
              <th>وضعیت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of FilteredList| paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: FilteredList.length
                      }; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item.PM_Code }}</td>
              <td>{{ item.PM_Title }}</td>
              <td>{{ item.Version }}</td>
              <td>{{ item.Count_Item || 0 }}</td>
              <td>{{ item.Time_Estimated || '-' }}</td>
              <td>

                <p *ngIf="item.Status" style="color: #489b39;">فعال</p>
                <p *ngIf="!item.Status" style="color: crimson;">غیر فعال</p>
              </td>
              <td>
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">امکانات</button>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" style="cursor: pointer;" (click)="Edit(item.id)"><i class="fa fa-edit"></i>
                      ویرایش</a>
                    <a *ngIf="item.Status==true" style="cursor: pointer;" class="dropdown-item"
                      (click)="openModal(template,item)"><i class="fa fa-lock"></i> غیرفعال </a>
                    <a *ngIf="item.Status==false" style="cursor: pointer;" class="dropdown-item"
                      (click)="openModal(template,item)"><i class="fa fa-unlock"></i> فعال </a>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="FilteredList.length === 0">
              <td colspan="8" class="text-center">رکوردی وجود ندارد.</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>

  <ng-template #template>
    <div class="modal-header">
      <h4 *ngIf="Data_Seleted_Delete.Status==true" class="modal-title pull-left">تایید غیرفعال اطلاعات الگو
        '{{Data_Seleted_Delete.title}}' </h4>
      <h4 *ngIf="Data_Seleted_Delete.Status==false" class="modal-title pull-left">تایید فعال اطلاعات الگو
        '{{Data_Seleted_Delete.title}}' </h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-footer">
      <button *ngIf="Data_Seleted_Delete.Status==true" type="button" class="btn btn-warning"
        (click)="Delete(Data_Seleted_Delete)"> غیرفعال اطلاعات <i class="fa fa-lock"></i></button>
      <button *ngIf="Data_Seleted_Delete.Status==false" type="button" class="btn btn-warning"
        (click)="Delete(Data_Seleted_Delete)"> فعال اطلاعات <i class="fa fa-unlock"></i></button>
      <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
    </div>
  </ng-template>